<template>
    <div :class="['move-item', 'move-item--'+status]" v-show="show">
        <div class="move-item__title">{{ item.title }}</div>
        <div class="move-item__body" v-if="item.status != 'success'">
            <div class="move-item__error" v-for="(error) in item.errors" :key="error.id">
                <div v-if="error.type == 'select'">
                    <div class="label">{{ error.text }}</div>
                    <v-select :id="error.id" v-model="error.selected" :options="error.options" class="form-vue-select">
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                </div>
                <div v-if="error.type == 'input'">
                    <div :class="['label',  {'label--required': error.required == 'true'}]">{{ error.text }}</div>
                    <input class="input" type="text" :id="error.id" v-model="error.selected" />
                </div>
                <div v-if="error.type == 'none'">
                    <div>{{ error.text }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        "item": {
            required: true,
        },
        "options": {
            required: true,
        },
    },
    computed: {
        status() {
            return this.calculateStatus();
        },
        show() {
            if (this.options.display_level == 'all') {
                return true;
            }
            if (this.options.display_level == 'some' && this.options.display_status.includes(this.status)) {
                return true;
            }
            return false;
        },
    },
    watch: {
        status() {
            this.item.status = this.status;
        }
    },

    methods: {
        calculateStatus() {
            if (this.item.errors) {
                var temp = this.item.errors.every(error => {
                    if (error.required && error.required == 'false') {  // e.g. optional input
                        return true;
                    }
                    return error.selected != null && error.selected != '';
                });
                if (temp) {
                    return 'warning';
                }
                return 'danger';
            }
            return 'success';
        },
    },

    mounted() {
        this.item.status = this.calculateStatus();
    },
}
</script>
